import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=a0a33d1e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=a0a33d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a33d1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0a33d1e')) {
      api.createRecord('a0a33d1e', component.options)
    } else {
      api.reload('a0a33d1e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=a0a33d1e&scoped=true&", function () {
      api.rerender('a0a33d1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fPX6oW4tXsFX/JS/teamMember.vue"
export default component.exports